(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('UnitDetailController', UnitDetailController);

    	UnitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'Unit','entity'];

        function UnitDetailController($scope, $rootScope, $stateParams, DataUtils, Unit, entity) {

/*//            vm.claimhospital = entity;
            vm.unit1 = [{code:'Tờ',description:'PYC, Tờ khai, Thư báo, …',status:'1'},
                         {code:'Quyển',description:'TR, RB, DKHD',status:'1'},
                         {code:'Bộ',description:'TR, RB, DKHD',status:'1'},
                         {code:'Cái',description:'TR, RB, DKHD',status:'1'}];
            vm.unit = vm.unit1[0];*/
        var vm = this;

        vm.unit = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.unit.status == 1){
        	vm.unit.statusName = 'Đang hoạt động'
        }else{
        	vm.unit.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:unitUpdate', function(event, result) {
            vm.unit = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
